module.exports = __webpack_public_path__ + "static/media/electric.3939d938.svg";